import { render, staticRenderFns } from "./AccountExtraCharges.vue?vue&type=template&id=472b9f09&"
import script from "./AccountExtraCharges.vue?vue&type=script&lang=js&"
export * from "./AccountExtraCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports